import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetCustomFieldsDto } from '../../../common/spdCore/autogenerated/spdApiClient';

import { Selector, Option } from './Selector';

export interface CustomFieldsSelectorProps {
  readOnly?: boolean;
  value?: string;
  placeholder?: string;
  className?: string;
  clearable?: boolean;
  onChange?: (option: Option) => void;
}

export const CustomFieldsSelector: React.FC<
  CustomFieldsSelectorProps
> = props => {
  const spd = useSpdCore();
  const [customFields, setCustomFields] = useState<GetCustomFieldsDto[]>([]);
  const [displayName, setDisplayName] = useState<string>('');
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (props.value) {
      spd.customFields
        .get(props.value || '')
        .then(customFields => {
          setDisplayName(customFields.name || '');
        })
        .catch(error =>
          console.log(`Problem z pobraniem pól dodatkowych: ${error}`),
        );
    } else {
      setDisplayName('');
    }
  }, [props.value, spd.customFields]);

  useEffect(() => {
    let mounted = true;
    spd.customFields
      .getAll()
      .then(dt => {
        if (mounted) {
          setCustomFields(dt);
          setReady(true);
        }
      })
      .catch(error =>
        console.log(`Problem z pobraniem pól dodatkowych: ${error}`),
      );

    return () => {
      mounted = false;
    };
  }, [spd.customFields]);

  const provider = async (text: string) => {
    const values = customFields.filter(v => {
      const name = v.name || '';
      return name.toLocaleLowerCase().includes(text.toLocaleLowerCase());
    });

    return values.map(v => {
      return {
        label: v.name || '',
        value: v.id,
      };
    });
  };

  return ready ? (
    <Selector
      uniqueKey={'customfields-' + displayName}
      className={props.className}
      readOnly={props.readOnly}
      creatable={false}
      clearable={props.clearable !== false}
      placeholder={props.placeholder || 'Wskaż...'}
      provider={provider}
      value={displayName}
      onChange={props.onChange}
    />
  ) : (
    <Skeleton />
  );
};
